import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import React from 'react';
import { useTranslation } from 'react-i18next';
import s from './LoadMoreFallback.scss';
const LoadMoreFallback = ({ isActive, fetchNext })=>{
    const { t } = useTranslation('nc');
    if (!isActive) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(GhostButton, {
        size: "large",
        variant: "main",
        onClick: ()=>fetchNext()
    }, t('nc:common.scrollLoadingFallback.button')));
};
LoadMoreFallback.displayName = 'LoadMoreFallback';
export default LoadMoreFallback;

//# sourceMappingURL=LoadMoreFallback.js.map